export default __webpack_public_path__ + "static/media/meal.c9392f24.png";